import type {
  AdvisorNotificationListResponse,
  AdvisorNotificationPreferences,
  AdvisorNotificationUnreadResponse,
} from "@repo/shared/types";
import { get, post, put } from "./_client";

const BASE = "/internal/notifications";

/** QL-728 — the bell: unread count and the latest few unread, newest first. */
export function getUnreadNotifications(): Promise<AdvisorNotificationUnreadResponse> {
  return get<AdvisorNotificationUnreadResponse>(`${BASE}/unread`);
}

/** One page of the inbox, newest first. */
export function listNotifications(cursor?: string): Promise<AdvisorNotificationListResponse> {
  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
  return get<AdvisorNotificationListResponse>(`${BASE}${query}`);
}

export function markNotificationRead(id: string): Promise<void> {
  return post<void>(`${BASE}/${id}/read`);
}

export function markAllNotificationsRead(): Promise<void> {
  return post<void>(`${BASE}/read-all`);
}

export function getNotificationPreferences(): Promise<AdvisorNotificationPreferences> {
  return get<AdvisorNotificationPreferences>(`${BASE}/preferences`);
}

/** Save a partial list of opt-ins; answers with the full list. */
export function updateNotificationPreferences(
  preferences: AdvisorNotificationPreferences,
): Promise<AdvisorNotificationPreferences> {
  return put<AdvisorNotificationPreferences>(
    `${BASE}/preferences`,
    preferences satisfies AdvisorNotificationPreferences,
  );
}

/** "A QP tab is visible" — keeps pushes to the phone off while the advisor is here. */
export function sendPresenceHeartbeat(): Promise<void> {
  return post<void>(`${BASE}/heartbeat`);
}
